import "core-js/modules/es6.array.find";
import "core-js/modules/es6.function.name";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import debounce from 'lodash/debounce';
import { mapGetters, mapActions } from 'vuex';
import { FAST_TIMER } from '~/const/timers';
import ProductCard from '~/components/molecules/Global/ProductCard.vue';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/night-light.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/technical-problem.svg';

var MdmModal = function MdmModal() {
  return import(
  /* webpackChunkName: "modal" */
  '~/components/atoms/Global/MdmModal.vue');
};

export default {
  name: 'AddToCartModal',
  components: {
    MdmModal: MdmModal,
    ProductCard: ProductCard
  },
  props: {
    showModal: {
      type: Boolean,
      required: true
    },
    product: {
      type: Object,
      required: true
    },
    isCrossProductExist: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      quantity: 1,
      show: false,
      btnDisabled: false
    };
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale',
    items: 'cart/items',
    successServer: 'cart/successServer'
  }), {
    productName: function productName() {
      return this.product.line ? "".concat(this.product.line, " - ").concat(this.product.name) : this.product.name;
    },
    cartUrl: function cartUrl() {
      return this.buildCartUrl(this.locale);
    },
    quantityTracking: function quantityTracking() {
      return {
        data: {
          event_category: 'FicheProduit',
          event_action: 'Clic_quantite',
          event_label: "".concat(window.tc_vars.page_cat1, "/").concat(window.tc_vars.page_cat2, "/").concat(window.tc_vars.page_cat3, "/").concat(window.tc_vars.page_cat4, "/").concat(window.tc_vars.page_cat5)
        }
      };
    }
  }),
  watch: {
    showModal: function showModal() {
      var _this = this;

      if (this.showModal && this.items) {
        var items = this.items.filter(function (e) {
          return e.productReference === _this.product.reference;
        });

        if (items.length > 1) {
          this.quantity = items.find(function (e) {
            return e.offer === _this.product.offer;
          }).quantity || 1;
        } else {
          this.quantity = items[0].quantity || 1;
        }
      }
    }
  },
  methods: _objectSpread({}, mapActions({
    updateCart: 'cart/update'
  }), {
    scrollToNextProducts: function scrollToNextProducts() {
      var positionNextFirstProduct = document.querySelector('#section-xsell-eb');

      if (positionNextFirstProduct) {
        window.scrollTo({
          top: positionNextFirstProduct.offsetTop - positionNextFirstProduct.offsetHeight / 4,
          behavior: 'smooth'
        });
      }

      this.$emit('onclosemodal');
    },
    debounceUpdateQty: debounce(function updateCartQuantity(event) {
      var _this2 = this;

      this.updateCart({
        reference: this.product.reference,
        offer: this.product.offer,
        quantity: this.quantity
      }).then(function () {
        _this2.btnDisabled = false;
      });
      this.trackQuantityChange(event);
    }, FAST_TIMER),
    decrementQuantity: function decrementQuantity() {
      if (parseInt(this.quantity, 10) <= 1) {
        return;
      }

      this.quantity = parseInt(this.quantity, 10) - 1;
    },
    incrementQuantity: function incrementQuantity() {
      if (parseInt(this.quantity, 10) >= 30) {
        return;
      }

      this.quantity = parseInt(this.quantity, 10) + 1;
    },
    trackQuantityChange: function trackQuantityChange(event) {
      this.$root.$emit('generic-tracking', event, this.quantityTracking);
    }
  })
};